export const roles = {
  ADMIN: 'ADMIN',
  SINGLE_STORE_MANAGER: 'SINGLE_STORE_MANAGER',
  LIMITED_SINGLE_STORE_MANAGER: 'LIMITED_SINGLE_STORE_MANAGER',
  STAFF_MEMBER: 'STAFF_MEMBER',
  KARMELEON: 'KARMELEON',
}
